// @mui material components
import { Grid, Tabs, Tab, Paper } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";

import { useState } from "react";

import AssetList from "./AssetList"

import BreakoutTab from "./BreakoutTab";
import RelationshipsTab from "./RelationshipsTab";
import ArtifactsTab from "./ArtifactsTab";

import TopNavBar from "../../components/TopNavBar/DefaultNavBar";

import assetCardData from "../../assets/assetJson/assets.json";
import satisfiedReq from "../../assets/requirementsJsons/satisfied_requirements.json";
import unsatisfiedReq from "../../assets/requirementsJsons/unsatisfied_requirements.json";

function AssetExplorer() {
    const bundleScoreData = [
    {
        cost: '$30000',
        timeline: '18mo',
        risk: 0.0,
        costScore: 89,
        timeScore: 49,
        riskScore: 100,
        overallScore: 71.0
    },
    ];

    const sortedAssetsByScore = [...assetCardData].sort((a, b) => b.score - a.score);
    
    const [bottomTabIndex, setBottomTabIndex] = useState(0);
    const [selectedAssetIndex, updateSelectedAssetIndex] = useState(0);
    const [filteredAssets, setFilteredAssets] = useState(sortedAssetsByScore);

    const handleFilteredDataChange = (newFilteredAssets) => {
        setFilteredAssets(newFilteredAssets);
        // Reset selected index if it's out of bounds
        if (selectedAssetIndex >= newFilteredAssets.length) {
            updateSelectedAssetIndex(0);
        }
    };

    {/*
        if (isLoading) {
            return (
            <DashboardLayout>
                <LoadingScreen isLoading={isLoading}/>
            </DashboardLayout>
            );
        }       
    */}

    return (
        <DashboardLayout>
            <TopNavBar />
            <MDBox>
                <Grid container spacing={2} sx={{alignItems: "stretch", height: "100%", display:"flex"}}>
                    <Grid item md={4}>
                        <AssetList 
                            assetData={sortedAssetsByScore} 
                            updateIndex={updateSelectedAssetIndex}
                            selectedIndex={selectedAssetIndex}
                            onFilteredDataChange={handleFilteredDataChange}
                        />
                    </Grid>
                    
                    <Grid item md={8}>
                        <MDBox flex="auto" bgColor="navy" borderRadius="lg">
                            <MDBox height="5px"/> 
                            <Paper sx={{ m: 1, p: 2 }}>
                                <MDTypography variant="h4" textTransform="capitalize">
                                    {filteredAssets[selectedAssetIndex]?.title || "No Asset Selected"}
                                </MDTypography>
                            </Paper>
                            <MDBox mx={1}>
                                <Tabs
                                    value={bottomTabIndex} 
                                    onChange={(_, index) => setBottomTabIndex(index)} 
                                    orientation="horizontal"
                                >
                                    <Tab label="Breakout"/>
                                    <Tab label="Project Management"/>
                                    <Tab label="Relationships"/>
                                    <Tab label="Artifacts"/>
                                </Tabs>
                            </MDBox>

                            <MDBox flex="auto" bgColor="grey-300" height="100%" mx={1}>
                                {bottomTabIndex === 0 && filteredAssets[selectedAssetIndex] && (
                                    <Grid container>
                                        <BreakoutTab
                                            assetSpecs={filteredAssets[selectedAssetIndex].specs}
                                            assetDescription={filteredAssets[selectedAssetIndex].description}
                                            assetCapabilities={filteredAssets[selectedAssetIndex].capabilities} 
                                            scoreData={bundleScoreData} 
                                            satisfiedReq={satisfiedReq}
                                            unsatisfiedReq={unsatisfiedReq}
                                        />
                                    </Grid>
                                )}

                                {bottomTabIndex === 1 && (
                                    <MDBox> 

                                    </MDBox>
                                )}

                                {bottomTabIndex === 2 && (
                                    <RelationshipsTab/>
                                )}

                                {bottomTabIndex === 3 && (
                                    <ArtifactsTab/>
                                )}
                            </MDBox>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default AssetExplorer;